import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "MANIFESTO", href: "#manifesto", id: "manifesto" },
  { label: "PROOF", href: "#track-record", id: "track-record" },
  { label: "AUDIT", href: "#audit", id: "audit" },
  { label: "ROSTER", href: "#roster", id: "roster" },
  { label: "RADIO", href: "#radio", id: "radio" },
  { label: "CREDIBILITY", href: "#credibility", id: "credibility" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 border-b ${
        scrolled
          ? "bg-[#08080A]/85 backdrop-blur-xl border-[#22222B]"
          : "bg-transparent border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img
            src="/assets/seal.jpg"
            alt="Plagiarhythm official seal"
            className="h-9 w-9 rounded-full object-cover border border-[#00F0FF]/60 group-hover:border-[#CCFF00] transition-colors duration-300"
          />
          <span className="mono text-xs tracking-[0.35em] text-[#F2F2F5] group-hover:text-[#00F0FF] transition-colors duration-300">
            PLAGIARHYTHM
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-6" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="mono text-[11px] tracking-[0.25em] text-[#A0A0AB] hover:text-[#00F0FF] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="mono text-[11px] tracking-[0.2em] px-4 py-2 border border-[#00F0FF]/50 text-[#00F0FF] hover:bg-[#00F0FF] hover:text-black transition-colors duration-300"
        >
          BOOK US
        </a>
      </div>
    </motion.header>
  );
}
